module.exports = __webpack_public_path__ + "static/media/img_7.4ce38dc4.png";